import { useMemo } from 'react'

import { createBrowserClient } from '@/supabase'

const useSupabase = () => {
  return useMemo(() => {
    return createBrowserClient()
  }, [])
}

export default useSupabase
